import ICLICommand from "flow/interfaces/ICLICommand";

export default {
    name: "help",
    description: "Show all commands and its description",
    options: [],
    arguments: [],
    callback: function (writer, optsAndArgs) {
        const candidates = optsAndArgs._commandRepository.getCommands();
        for (let i = 0; i < candidates.length; ++i) {
            if (candidates[i].name.indexOf(name) === 0) {
                writer.help.writeLine(candidates[i].name);
                writer.output.writeLine(candidates[i].description);
                writer.output.writeLine(" ");
            }
        }

        writer.output.writeLine("\n");
        writer.output.writeLine("man <command> for more information about the command.");
        return { input: "" };
    }
} as ICLICommand;
